module.exports = __webpack_public_path__ + "img/driver.09360074.svg";